import { render } from "./course-information.vue?vue&type=template&id=5b34d4b5"
import script from "./course-information.vue?vue&type=script&lang=js"
export * from "./course-information.vue?vue&type=script&lang=js"

import "./course-information.vue?vue&type=style&index=0&id=5b34d4b5&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__